<template>
  <div class="flex flex-col items-center w-full space-y-5">
    <img src="@/assets/icons/ok-icon.svg" alt="" class="h-32 w-32"/>
    <h2 class="text-32px xs:text-2xl font-bold text-center mb-5 max-w-348px">
      {{ $t('video_interview.interview-finished') }}
    </h2>
    <p class="text-neutral-50 text-base xs:text-sm text-center mb-5">
      {{ $t('video_interview.answer-successfuly-sent') }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'FinnishScreen',
};
</script>
<style lang="scss">

</style>
